import type { BatMetadataConfigEntry } from './common/types';
import { coreFields, genericUnitField } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productCategoryField, productFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import {
  fuelConsumptionUnitField,
  fuelKindField,
  lifetimeFuelConsumptionField,
} from './common/fuelFields';
import {
  lifetimeElectricityConsumptionField,
  lifetimeElectricityConsumptionUnitField,
} from './common/electricityFields';

export const lifetimeFuelAndElectricityUseOfSoldProductsMetadata = {
  displayName: msg({
    message: 'Sold products: Lifetime consumption',
    context:
      'Activity data schema name for lifetime fuel and electricity use of sold products',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    fuel_consumption_unit: fuelConsumptionUnitField,
    fuel_kind: fuelKindField,
    lifetime_electricity_consumption: {
      ...lifetimeElectricityConsumptionField,
      externalDescription: msg({
        message: 'The electricity usage over the lifetime of a sold product.',
        context: 'Lifetime electricity consumption',
      }),
    },
    lifetime_electricity_consumption_unit:
      lifetimeElectricityConsumptionUnitField,
    lifetime_fuel_consumption: {
      ...lifetimeFuelConsumptionField,
      externalDescription: msg({
        message: 'The fuel consumption over the lifetime of a sold product.',
        context: 'Lifetime fuel consumption',
      }),
    },
    product_category: productCategoryField,
    quantity: {
      displayName: msg({
        message: 'Number of sold products',
        context: 'The quantity of sold product.',
      }),
      externalDescription: msg({
        message: 'The quantity of sold product.',
        context: 'Number of sold products',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
